export default __webpack_public_path__ + "static/media/CorrectAnswer3.3d5f0bd1.mp3";